import React, {Component} from 'react';
import {Badge, Input} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../../../constants/configs';
import {getDatePickerProps, i18nizeDate, numberWithCommas} from '../../../../helpers/Utils';
import {createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import ToolTip from "../../../../components/ToolTip";
import {keyBy, mapValues, omit} from "lodash";
import Api from "../../../../services/Api";
import {Link} from "react-router-dom";
import ReactTable from 'react-table';
import i18n from "../../../../services/i18n";
import fa_IR from "../../../../constants/locales";
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import moment from "moment/moment";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: false,
      since: null,
    };
  }

  fetchData = async state => {
    const {since} = this.state;
    const {id, type} = this.props;
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        `/v2/admin-ui/boards/${id}/stats`,
        null,
        {
          params: {
            type,
            offset,
            limit: state.pageSize,
            since: since ? moment(since).toISOString() : null,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        });
      this.setState({
        users: data,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    }, async () => {
      await this.fetchData(this.table.state);
    });
  };

  getDisplacementIcon = (first, second) => {
    if (second > first) {
      return "icon-Arrow-Up";
    }
    if (second < first) {
      return "icon-Arrow-Down";
    }
    return null;
  }

  getDisplacementValue = (first, second) => {
    return numberWithCommas(`${Math.abs(second - first)}`);
  };

  getDisplacementColor = (first, second) => {
    if (second > first) {
      return "success";
    }
    if (second < first) {
      return "danger";
    }
    return "light";
  };

  getColumns = t => [
    {
      Header: t('Rank'),
      accessor: 'rank',
      Cell: props => {
        const {preRank} = props.original;
        return (
          <div className="d-flex align-items-center">
            {typeof props.value === "number" ?
              <div className="text-one font-weight-semibold mr-2">
                {numberWithCommas(props.value)}
              </div> :
              <Badge color="secondary">
                {t("New")}
              </Badge>
            }
            {typeof preRank === "number" &&
              <Badge color={this.getDisplacementColor(props.value, preRank)}>
                <i className={`${this.getDisplacementIcon(props.value, preRank)} font-weight-semibold ml-1`}/>
                {this.getDisplacementValue(props.value, preRank)}
              </Badge>
            }
          </div>
        );
      }
    },
    {
      Header: t('Score'),
      accessor: 'score',
      Cell: props => {
        const {preScore} = props.original;
        return (
          <div className="d-flex align-items-center">
            {typeof props.value === "number" ?
              <div className="text-one font-weight-semibold mr-2">
                {numberWithCommas(props.value)}
              </div> :
              <Badge color="secondary">
                {t("New")}
              </Badge>
            }
            {typeof preScore === "number" &&
              <Badge color={this.getDisplacementColor(preScore, props.value)}>
                <i className={`${this.getDisplacementIcon(preScore, props.value)} font-weight-semibold ml-1`}/>
                {this.getDisplacementValue(preScore, props.value)}
              </Badge>
            }
          </div>
        );
      }
    },
    {
      Header: t('User'),
      accessor: 'user',
      Cell: props => {
        if (props.value) {
          const {nickname, email, phoneNumber} = props.value;
          return (
            <span>{nickname || email || phoneNumber}</span>
          );
        }
        return null;
      },
    },
    {
      Header: t('Date of entering the board'),
      accessor: 'startTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 200,
    },
    {
      Header: t('Actions'),
      accessor: 'user.id',
      width: 100,
      Cell: props =>
        <div className='d-flex flex-row align-items-center'>
          <ToolTip id={`view_${props.value}`} text={t('View Profile')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.value,
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        </div>,
    },
  ];

  render() {
    const {t} = this.props;
    const {since} = this.state;
    return (
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }})
        }
      >
        <MuiPickersUtilsProvider
          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
          locale={i18n.language}
        >
          <div className="d-flex align-items-center my-4 col-lg-4 col-12">
            <div style={{minWidth: 85}}>{t('start date')}</div>
            <DateTimePicker
              {...getDatePickerProps()}
              minDate={undefined}
              maxDate={undefined}
              TextFieldComponent={props => <Input className="datePickerInput" {...props} placeholder={t("since campaign started")} />}
              onChange={date => {this.handleDateChange('since', date);}}
              value={since}
            />
          </div>
          <ReactTable
            manual
            ref={el => {this.table = el;}}
            className="-highlight"
            data={this.state.users}
            loading={this.state.loading}
            sortable={true}
            resizable={true}
            showPagination={false}
            onFetchData={this.fetchData}
            columns={this.getColumns(t)}
            defaultPageSize={10}
            style={{
              width: '100%'
            }}
            {...reactTableText}
          />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

export default withTranslation()(List);
